import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
  /**
   * 取得 服務介紹群組
   */
  fetchServuceGroup({ commit }) {
    return request
      .post(`merchant/service/price/group/search`, {
        paginate: 0,
      }, {
        ...configRequest,
        name: 'fetchServuceGroup',
      })
      .then((response) => response)
  },
};
